<template>
<div class="page_pay">
	<div class="plat-wrap plat-cangpin" v-if="type == 'cangpin'">
		<!-- 绑微信提醒  -->
		<div class="wechat_tips" v-if="!bindWX">
			<div class="tips_left">请绑定微信</div>
			<div class="tips_right">
				<div class="small-btn" @click="bandwechat">绑定</div>
			</div>
		</div>
		<!-- 订单信息 -->
		<div class="order">
			<div class="pay-money">¥{{ price }}</div>
		</div>
		<!-- 支付方式 -->
		<div class="payList">
			<van-checkbox-group v-model="checkedPay">
				<van-cell-group>
					<van-cell class="item" v-for="(item,index) in payMent" :key="index" @click="togglePayMent(index)">
						<template #title>
							<img :src="item.cangpinIcon" alt="" class="tu">
							<span class="title">{{item.cangpinName}}</span>
						</template>
						<template #right-icon>
							<van-checkbox :name="item.id" :disabled="item.status ? false : true" checked-color="#0E0E0E" ref="checkboxesPay"></van-checkbox>
						</template>
					</van-cell>
				</van-cell-group>
			</van-checkbox-group>
			<!-- 平台充值卡 -->
			<van-checkbox-group v-model="cardResult" v-if="checkedPay.indexOf(2) != -1">
				<van-cell-group>
					<van-cell class="item" v-for="(item,index) in cardList" :key="index" @click="toggleCard(index)">
						<template #title>
							<span class="title">{{item.name}}</span>
						</template>
						<template #right-icon>
							<van-checkbox :name="item.id"  checked-color="#0E0E0E" ref="checkboxesCard"></van-checkbox>
						</template>
					</van-cell>
				</van-cell-group>
			</van-checkbox-group>
		</div>
		<div class="action">
			<div class="pay" @click="cangpinTijiao">立即支付</div>
		</div>
	</div>
	<div class="plat-wrap" v-if="type != 'cangpin'">
		<!-- 绑微信提醒 -->
		<div class="wechat_tips" v-if="!bindWX" @click="bandwechat">
			<div class="tips_left">请绑定微信</div>
			<div class="tips_right">
				<img :src="publicPath+'statics/images/weixin-2.png'" alt="" class="icon_wechat">
				<img :src="publicPath+'statics/images/icon_right_grey.png'" alt="" class="icon_right">
			</div>
		</div>
		<!-- 订单信息 -->
		<div class="order">
			<div class="order_tips">订单已提交</div>
			<div class="order_number">支付订单号：{{ orderId }}</div>
		</div>
		<!-- iyiqi 积分支付 -->
		<div class="payList" v-if="iyiqiUser">
			<van-cell class="item">
				<template #title>
					<img :src="publicPath + 'statics/images/shop/icon_jifen.png'" alt="" class="tu">
					<span class="title">积分支付</span>
				</template>
				<template #right-icon>
					<van-checkbox v-model="iyiqiPay">
						<template #icon="props">
							<img class="img-icon" :src="props.checked ? activeIcon_plat : inactiveIcon_plat">
						</template>
					</van-checkbox>
				</template>
			</van-cell>
		</div>
		<!-- 支付方式 -->
		<div class="payList">
			<van-checkbox-group v-model="checkedPay">
				<van-cell-group>
					<van-cell class="item" v-for="(item,index) in payMent" :key="index" @click="togglePayMent(index)">
						<template #title>
							<img :src="item.icon" alt="" class="tu">
							<span class="title">{{item.name}}</span>
						</template>
						<template #right-icon>
							<van-checkbox :name="item.id" ref="checkboxesPay">
								<template #icon="props">
									<img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon">
								</template>
							</van-checkbox>
						</template>
					</van-cell>
				</van-cell-group>
			</van-checkbox-group>
			<!-- 平台体验券 -->
			<van-checkbox-group v-model="cardResult" v-if="checkedPay.indexOf(2) != -1">
				<van-cell-group>
					<van-cell class="item" v-for="(item,index) in cardList" :key="index" @click="toggleCard(index)">
						<template #title>
							<span class="title">{{item.name}}</span>
						</template>
						<template #right-icon>
							<van-checkbox :name="item.id" ref="checkboxesCard">
								<template #icon="props">
									<img class="img-icon" :src="props.checked ? activeIcon_plat : inactiveIcon_plat">
								</template>
							</van-checkbox>
						</template>
					</van-cell>
				</van-cell-group>
			</van-checkbox-group>
		</div>
		<div class="action">
			<div class="pay" @click="tijiao">立即支付¥{{ price }}</div>
		</div>
	</div>   
	<!-- 未支付时,离开页面给提醒 -->
	<van-dialog v-model="showPayTips" title="是否取消支付" message="您的订单在2小时内未支付将被取消，请尽快完成支付。" show-cancel-button cancel-button-text="继续支付" confirm-button-text="确认离开" @cancel="cancelTips" @confirm="confirmTips">
	</van-dialog>
	<!-- loading -->
	<van-overlay :show="submitLoading">
        <div class="wrapper"><van-loading type="spinner" /></div>
    </van-overlay>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import { Dialog } from 'vant';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    // name: "map-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            orderId: null,
            price: null,
            token: null,
            activeIcon: process.env.BASE_URL + 'statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
			from: null,
            activeIcon_plat: process.env.BASE_URL + 'statics/images/active_square.png',
            inactiveIcon_plat: process.env.BASE_URL + 'statics/images/inactive_square.png',
			bindWX: false, // 是否绑定微信
			type: '', // 默认是约看, video 视频, cangpin 藏品
			showPayTips: false, // 未支付,离开页面时的提示层
			is_pay: false, // 是否支付
			payMent: [{
                id: 3,
                name: '微信支付',
                icon: process.env.BASE_URL + 'statics/images/shop/icon_wechat.png',
				cangpinName: '微信',
				cangpinIcon: process.env.BASE_URL + 'statics/images/cangpin/pay-wechat.png',
				status: 1
            } ],
            checkedPay: [],
			cardList: [],
			cardResult: [],
			is_chargecard: null, // 是否允许用体验券 1是 0否
			submitLoading: false, // 用于点击控制 藏品支付用了
			iyiqiUser: null, //  iyiqi 积分支付相关
			iyiqiToken: null,
			iyiqiPhone: null,
			iyiqiPay: false
        };
	},
	beforeRouteLeave(to,from,next){
        let that = this
		if(to.name == 'set-account' || to.name == 'pay-success' || to.name == 'cangpin-account'){
			next()
		}else{
            if(!this.is_pay){
                Dialog.confirm({
                title: '是否取消支付',
                message: '您的订单在2小时内未支付将被取消，请尽快完成支付。',
                showConfirmButton:true,
                confirmButtonText: '确认离开',
                cancelButtonText:'继续支付',
                showCancelButton: true,
                closeOnPopstate: false,
                // theme: 'round-button',
                }).then(() => {
                    console.log('确认离开')
                    that.is_pay = true
                    that.$router.back(-1)
                }).catch(()=>{
                    console.log('继续支付')
                });
                next(false)
            } else {
                next()
            }
		}
    },
    components: {
        // PageSearch
    },
    created: function () {
        this.orderId = this.$route.query.orderId;
        this.price = this.$route.query.price;
		this.is_chargecard = this.$route.query.is_chargecard;
        this.type = this.$route.query.type;
		this.from = this.$route.query.from;
		if(this.type == 'cangpin'){
			window.document.title = '数字藏品';
		};
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '支付'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            console.log('sdjy://member/memberInfo')
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getUserData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
                
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.getUserData();
			if(this.token && this.type != 'cangpin' && this.type != 'video'){
				this.verfyiyiqi();
			}
        };
		
    },
	watch: {
		'iyiqiPay': function(val){
			// 一经选中iyiqi的积分支付,其余支付方式都不可选
			if(val){
				this.checkedPay = [];
				this.cardResult = [];
				for(let i in this.payMent){
					this.payMent[i].status = 0;
				};
			}else{
				for(let i in this.payMent){
					this.payMent[i].status = 1;
				};
			}
		}
	},
    methods: {
		/**
		 * @name: 验证是否为iyiqi用户
		 * @return {*}
		 * @desc: 
		 */		
		verfyiyiqi(){
			let params = {
				token: this.token
			};
			this.$api.my.isiyiqiuser(params).then(res=>{
				if(res.code == 200){
					this.iyiqiUser = res.result.is_user;
					this.iyiqiToken = res.result.iyiqi_token;
					this.iyiqiPhone = res.result.phone;
				}
			})
		},
		/**
		 * @name: 藏品的微信支付
		 * @param {*} config
		 * @return {*}
		 * @desc: 
		 */		
		weChatPayCangpin(config){
			let that = this;
			wx.config({
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				appId: config.appId, // 必填，公众号的唯一标识
				timestamp: config.timeStamp, // 必填，生成签名的时间戳
				nonceStr: config.nonceStr, // 必填，生成签名的随机串
				signature: config.paySign, // 必填，签名，见附录1
				jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
			});
			// 配置失败返回
			wx.error(function (res) {
				console.log('微信支付配置失败',res);
				that.submitLoading = false;
			});
			wx.ready(function(){
				// 调起微信支付
				wx.chooseWXPay({
					timestamp: config.timeStamp,
					nonceStr: config.nonceStr,
					package: config.package,
					signType: config.signType,
					paySign: config.paySign,
					success: function(res){
						// 支付成功
						that.$toast('支付成功');
						let url = that.$publicData.cangpinUrl+'/my/order?from=h5';
						window.open(url);
						that.submitLoading = false;
					},
					error: function(res){
						that.$toast('支付失败');
						let url = that.$publicData.cangpinUrl+'/my/order?from=h5';
						window.open(url);
						that.submitLoading = false;
					},
					cancel: function(res){
						that.$toast('已取消支付');
						let url = that.$publicData.cangpinUrl+'/my/order?from=h5';
						window.open(url);
						that.submitLoading = false;
					} 
				})
			})
		},
		/**
		 * @name: 数字藏品的支付
		 * @return {*}
		 * @desc: 
		 */		
		cangpinTijiao(){
			let that = this;
            if (this.checkedPay.length == 0 ) {
                this.$toast('请选择支付方式')
                return
            };
			if(this.checkedPay.indexOf(2) != -1 && this.cardResult.length == 0){
				this.$toast('请选择充值卡');
				return;
			};
			try {
				that.submitLoading = true;
				let params = {
					token: this.token,
					pay_order_num: this.orderId,
					pay_name: this.checkedPay.join(',')
				};
				if(this.cardResult.length){
					params.chargecard_ids = this.cardResult.join(',');
				};
				if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
					params.tag = 1;
				};
				this.$api.my.paycangpin(params).then(res=>{
					if(res.code == 200){
						let data = res.result;
						if(data.config){
							// 配置微信config
							that.weChatPayCangpin(data.config);
						}else{
							// 支付成功
							window.history.replaceState(null,null,that.$publicData.domain+"?back=cangpin")
							let url = that.$publicData.cangpinUrl+'/my/order?from=h5';
							console.log('跳转链接',url)
							window.open(url,'_self');
							that.submitLoading = false;
						}
					}else{
						that.submitLoading = false;
					}
				})
			} catch (error) {
				console.log('有报错',error);
				that.submitLoading = false;
			}
			
		},
        /**
         * @name: 提交支付
         * @return {*}
         * @desc: 
         */		
        tijiao() {
			let that = this;
			if(this.iyiqiUser){
				if(!this.iyiqiPay && this.checkedPay.length == 0){
					this.$toast('请选择支付方式')
                	return
				}
			}else{
				if (this.checkedPay.length == 0 ) {
					this.$toast('请选择支付方式')
					return
				};
			}
			if(this.iyiqiPay){
				let parames = {
					token: this.iyiqiToken,
					phone: this.iyiqiPhone,
					businessNum: this.orderId,
					payMoney: this.price,
					sourceType: 4, // 0:uniapp 1:微信小程序  2:ios   3:Android ;else 其他是H5
					backToUrl: this.$publicData.domain+'/yuekan/order/index',
					backType: 2 // 1商城 2约看 3定制
				};
				let url = this.$publicData.iyiqiUrl+'?parames='+encodeURIComponent(JSON.stringify(parames));
				window.open(url,'_self');
			}else{
				// return;
				// 约看 type 为null , 视频 type为video
				if(this.type == 'video'){
					// 视频仅支付微信支付
					let params = {
						token: this.token,
						order_num: this.orderId,
					};
					if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
						params.tag = 1;
					};
					this.$api.living.payVideoOrder(params).then(res => {
						if (res.code == 200) {
							let data = res.result;
							if(data.config){
								if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
									let p = data.config;
									p.url = this.$publicData.clientUrl + '/pay/success?orderId='+this.orderId
									let params = {
										'data': p
									}
									this.$bridge.callhandler('sdjy://public/wxPay', params, (data) => {
										
									})
									return
								};
								// 配置微信config
								wx.config({
									debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
									appId: data.config.appId, // 必填，公众号的唯一标识
									timestamp: data.config.timeStamp, // 必填，生成签名的时间戳
									nonceStr: data.config.nonceStr, // 必填，生成签名的随机串
									signature: data.config.paySign, // 必填，签名，见附录1
									jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
								});
								wx.ready(function () {
									// 调起微信支付
									wx.chooseWXPay({
										timestamp: data.config.timeStamp,
										nonceStr: data.config.nonceStr,
										package: data.config.package,
										signType: data.config.signType,
										paySign: data.config.paySign, // 支付签名
										success: function (res) {
											console.log('success')
											console.log(res)
											// 支付成功，转到订单列表页面
											if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
												var params = {
													'data': {
														'url': that.$publicData.clientUrl + '/pay/success?type=video' 
													}
												}
												that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

												})
											} else {
												that.$router.push({
													path: '/pay/success',
													query: {
														type: 'video',
														from: that.from
													}
												})
											}
										},
										error: function (res) {

										},
										cancel: function (res) {

										}
									});
								});
								// 配置失败返回
								wx.error(function (res) {
									// that.$toast("微信支付配置失败！");
									// that.loading = false;
									console.log('error')
									console.log(res)
									// setTimeout(function () {
									//     location.href = "{{ url('pay',['oid'=>$oid]) }}";
									// }, 2000);
								});
							}else{
								if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
									var params = {
										'data': {
											'url': this.$publicData.clientUrl + '/pay/success?type=video'
										}
									}
									this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

									})
								} else {
									this.$router.push({
										path: '/pay/success',
										query: {
											type: 'video',
											from: that.from
										}
									})
								}
							};
						} 
						else {
							this.$toast(res.message)
						}
					})
				}else{
					if(this.checkedPay.indexOf(2) != -1 && this.cardResult.length == 0){
						this.$toast('请选择体验券');
						return;
					};
					let params = {
						token: this.token,
						order_num: this.orderId,
						pay_name: this.checkedPay.join(',')
					};
					if(this.cardResult.length){
						params.chargecard_ids = this.cardResult.join(',');
					};
					if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
						params.tag = 1;
					};
					this.$api.live.livePay(params).then(res => {
						if (res.code == 200) {
							let data = res.result;
							if(data.config){
								let config = data.config.config;
								if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
									let p = config;
									p.url = this.$publicData.clientUrl + '/pay/success?orderId='+this.orderId
									let params = {
										'data': p
									}
									this.$bridge.callhandler('sdjy://public/wxPay', params, (data) => {
										
									})
									return
								} 
								// 配置微信config
								wx.config({
									debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
									appId: config.appId, // 必填，公众号的唯一标识
									timestamp: config.timeStamp, // 必填，生成签名的时间戳
									nonceStr: config.nonceStr, // 必填，生成签名的随机串
									signature: config.paySign, // 必填，签名，见附录1
									jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
								});
								wx.ready(function () {
									// 调起微信支付
									wx.chooseWXPay({
										timestamp: config.timeStamp,
										nonceStr: config.nonceStr,
										package: config.package,
										signType: config.signType,
										paySign: config.paySign, // 支付签名
										success: function (res) {
											console.log('success')
											console.log(res)
											// 支付成功，转到订单列表页面
											if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
												var params = {
													'data': {
														'url': that.$publicData.clientUrl + '/pay/success?orderId='+this.orderId
													}
												}
												that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

												})
											} else {
												that.$router.push({
													path: '/pay/success',
													query: {
														type: 'yuekan',
														from: that.from,
														orderId: that.orderId
													}
												})
											}
										},
										error: function (res) {

										},
										cancel: function (res) {

										}
									});
								});
								// 配置失败返回
								wx.error(function (res) {
									// that.$toast("微信支付配置失败！");
									// that.loading = false;
									console.log('error')
									console.log(res)
									// setTimeout(function () {
									//     location.href = "{{ url('pay',['oid'=>$oid]) }}";
									// }, 2000);
								});
							}else{
								if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
									var params = {
										'data': {
											'url': this.$publicData.clientUrl + '/pay/success?orderId='+this.orderId
										}
									}
									this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

									})
								} else {
									this.$router.push({
										path: '/pay/success',
										query: {
											type: 'yuekan',
											from: that.from,
											orderId: that.orderId
										}
									})
								}
							}
						} 
						else {
							this.$toast(res.message)
						}
					})
				}
			}
        },
        /**
         * @name: 获取用户信息
         * @return {*}
         * @desc: 
         */		
        getUserData() {
            if (this.token == null) {
                return
            }
            var params = {
                token: this.token
            }
            this.$api.user.index(params).then(res => {
                if (res.code == 200) {
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        if (res.result.info.users.app_openid && res.result.info.users.app_openid != undefined && res.result.info.users.app_openid != '') {
                            this.bindWX = true
                        } else {
                            this.bindWX = false
                        }
                    } else {
                        if (res.result.info.users.openid && res.result.info.users.openid != undefined && res.result.info.users.openid != '') {
                            this.bindWX = true
                        } else {
                            this.bindWX = false
                        }
                    };
					if(this.type != 'video'){
						// 余额
						let userMoney = res.result.usercount.user_money;
						if(userMoney > 0){
							this.payMent.push({
								id: 1,
								name: '余额 (可用余额：¥'+ userMoney +')',
								icon: process.env.BASE_URL + 'statics/images/shop/icon_balance.png',
								cangpinName: '余额 (可用余额：¥'+ userMoney +')',
								cangpinIcon: process.env.BASE_URL + 'statics/images/cangpin/icon-pay-yue.png',
								status: 1
							})
						};
						// 体验券
						let cardMoney = res.result.card_money;
						if(this.type == 'cangpin' && cardMoney > 0){
							this.payMent.push({
								id: 2,
								name: '体验券',
								icon: process.env.BASE_URL + 'statics/images/shop/icon_charge.png',
								cangpinName: '充值卡',
								cangpinIcon: process.env.BASE_URL + 'statics/images/cangpin/icon-pay-ka.png',
								status: 1
							});
							this.getChargeCard();
						}else if(this.is_chargecard == 1 && cardMoney > 0){
							this.payMent.push({
								id: 2,
								name: '体验券',
								icon: process.env.BASE_URL + 'statics/images/shop/icon_charge.png',
								cangpinName: '充值卡',
								cangpinIcon: process.env.BASE_URL + 'statics/images/cangpin/icon-pay-ka.png',
								status: 1
							});
							this.getChargeCard();
						}
					}
                }
            })
        },
		/**
		 * @name: 获取平台体验券
		 * @return {*}
		 * @desc: 只处理有余额的卡
		 */		
		getChargeCard(){
			let params = {
				token: this.token,
                tag: 1,
                page: 1,
                size: 100
			};
			this.$api.my.cardList(params).then(res=>{
				if(res.code == 200){
					let arr = [];
					let list = res.result.list;
					for(let i in list){
						let card = list[i];
						if (card.reset_money > 0){
							let obj = {
								id: card.id,
                                name: '卡号：' + card.number + ' 余额：￥' + card.reset_money
							};
							arr.push(obj);
						}
					};
					this.cardList = arr;
				}
			})
		},
		/**
		 * @name: 支付方式点选
		 * @param {*} index
		 * @return {*}
		 * @desc: 
		 */		
		togglePayMent(index) {
            this.$refs.checkboxesPay[index].toggle();
        },
		/**
		 * @name: 体验券点选
		 * @return {*}
		 * @desc: 
		 */		
		toggleCard(index){
			this.$refs.checkboxesCard[index].toggle();
		},
        // 绑定微信
        bandwechat() {
			if(this.type == 'cangpin'){
				let url = this.$publicData.cangpinUrl+'/my/set';
				window.open(url,'_self');
			}else{
				this.$router.push({
					path: '/set/account'
				})
			}
		},
		// 继续支付
		cancelTips(){
			this.is_pay = false
			this.showPayTips = false
		},
		// 确认离开
		confirmTips(){
			this.is_pay = true
			this.showPayTips = false;
			if(this.type == 'cangpin'){
				let url = this.$publicData.cangpinUrl;
				window.open(url);
			}else{
				this.$router.back(-1);
			}
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
	.page_pay {
		padding-bottom: 2.4rem;
	}
	.page_pay .action{
		padding: 0.4rem 0.53rem;
		bottom: 0;
	}
	/* 数字藏品的支付 */
	.plat-cangpin .wechat_tips{
		background-color: rgb(148, 239, 198);
		color: rgb(14, 14, 14);
	}
	.plat-cangpin .wechat_tips .small-btn{
		font-size: .32rem;
		width: 1.34rem;
		height: 0.706rem;
		line-height: .706rem;
		border-radius: 0.33rem;
		background: #FFFFFF;
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 0.12rem;
		right: 0.53rem;
	}
	.plat-cangpin .pay-money{
		font-size: .8rem;
		font-weight: bold;
		color: #0E0E0E;
		text-align: center;
		padding-top: 1.067rem;
	}
	.plat-cangpin .payList::before{
		display: none;
	}
	.plat-cangpin .payList .item{
		border-bottom: 0 none;
	}
	.plat-cangpin .action{
		box-shadow: 0 0.0267rem 0.134rem 0 rgb(0,0,0,.1);
	}
	.plat-cangpin .action .pay{
		background: #0E0E0E;
	}
	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}
</style>
